// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

let baseStyles = Emotion.Css.css({
  width: "100%",
  fontFamily: "inherit",
  fontSize: "1rem",
  lineHeight: "1.6",
  border: "none",
  outline: "none",
  resize: "vertical",
  minHeight: "8rem",
  transition: Emotion.Utils.Animate.getDuration("fast") + " ease-out",
  backgroundColor: "transparent"
});

function getVariantStyles(variant) {
  if (variant === "filled") {
    return Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.bgElevated,
      border: "1px solid transparent",
      borderRadius: Emotion.Utils.Border.getRadius("md"),
      color: Emotion.Utils.Color.textPrimary,
      padding: "0.75rem 0.875rem",
      ":focus": {
        backgroundColor: Emotion.Utils.Color.bgSecondary,
        borderColor: Emotion.Utils.Color.primary,
        boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
      }
    });
  } else if (variant === "default") {
    return Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.bgSecondary,
      border: `1px solid ` + Emotion.Utils.Color.border,
      borderRadius: Emotion.Utils.Border.getRadius("md"),
      color: Emotion.Utils.Color.textPrimary,
      padding: "0.75rem 0.875rem",
      ":focus": {
        borderColor: Emotion.Utils.Color.primary,
        boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
      }
    });
  } else if (variant === "outlined") {
    return Emotion.Css.css({
      backgroundColor: "transparent",
      border: `2px solid ` + Emotion.Utils.Color.border,
      borderRadius: Emotion.Utils.Border.getRadius("md"),
      color: Emotion.Utils.Color.textPrimary,
      padding: "0.75rem 0.875rem",
      ":focus": {
        borderColor: Emotion.Utils.Color.primary,
        boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
      }
    });
  } else if (variant === "editorial") {
    return Emotion.Css.css({
      minHeight: "24rem",
      resize: "none",
      backgroundColor: "transparent",
      border: "none",
      borderRadius: Emotion.Utils.Border.getRadius("sm"),
      padding: "0.2rem",
      marginInline: "-0.2rem",
      color: Emotion.Utils.Color.textPrimary,
      fontFamily: Theme.Theme.Typography.fontFamily.serif,
      fontSize: "1.2rem",
      lineHeight: "1.8",
      ":focus": {
        backgroundColor: Emotion.Utils.Color.bgSecondary
      }
    });
  } else {
    return Emotion.Css.css({
      backgroundColor: "transparent",
      border: "none",
      borderBottom: `2px solid ` + Emotion.Utils.Color.border,
      borderRadius: "0",
      color: Emotion.Utils.Color.textPrimary,
      padding: "0.5rem 0",
      ":focus": {
        borderBottomColor: Emotion.Utils.Color.primary
      }
    });
  }
}

function getStateStyles(state) {
  if (state === "warning") {
    return Emotion.Css.css({
      borderColor: Emotion.Utils.Color.warning
    });
  } else if (state === "default") {
    return "";
  } else if (state === "success") {
    return Emotion.Css.css({
      borderColor: Emotion.Utils.Color.success
    });
  } else {
    return Emotion.Css.css({
      borderColor: Emotion.Utils.Color.error
    });
  }
}

function Textarea$Textarea(props) {
  let __required = props.required;
  let __rows = props.rows;
  let __className = props.className;
  let __readOnly = props.readOnly;
  let __disabled = props.disabled;
  let __state = props.state;
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "default";
  let state = __state !== undefined ? __state : "default";
  let disabled = __disabled !== undefined ? __disabled : false;
  let readOnly = __readOnly !== undefined ? __readOnly : false;
  let className = __className !== undefined ? __className : "";
  let rows = __rows !== undefined ? __rows : 6;
  let required = __required !== undefined ? __required : false;
  let textareaClassName = Emotion.Css.cx([
    baseStyles,
    getVariantStyles(variant),
    getStateStyles(state),
    Emotion.Css.css({
      "::placeholder": {
        color: Emotion.Utils.Color.placeholder,
        opacity: "1"
      }
    }),
    disabled ? Emotion.Css.css({
        opacity: "0.5",
        cursor: "not-allowed"
      }) : "",
    className
  ]);
  return JsxRuntime.jsx("textarea", {
    "aria-label": props.ariaLabel,
    defaultValue: props.defaultValue,
    className: textareaClassName,
    id: props.id,
    disabled: disabled,
    maxLength: props.maxLength,
    name: props.name,
    placeholder: props.placeholder,
    readOnly: readOnly,
    required: required,
    rows: rows,
    value: props.value,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    onChange: props.onChange
  });
}

let Textarea = {
  baseStyles: baseStyles,
  getVariantStyles: getVariantStyles,
  getStateStyles: getStateStyles,
  make: Textarea$Textarea
};

export {
  Textarea,
}
/* baseStyles Not a pure module */
